import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { selectCurrentTableKey } from '@/redux/selectors/dataTableSelectors';
import DataTableLayout from '../_common/Layout/DataTableLayout';
import DataTableTitleBar from '../_common/Layout/DataTableTitleBar';
import { selectCanReadTitles } from '../../redux/selectors/authSelectors';
import NoRoute from '../NoRoute/NoRoute';
import DataTableFilters from '../_common/Filters/DataTableFilters';
import { useAppSelector } from '@/redux/hooks';
import { ConfigContext } from '@/contextAPI/configContext';
import TitlesV2 from '@/components/Titles/v2/TitlesV2';
import { TitleEntity } from '@/redux/slices/slice_types';

// TODO(TMT-6046): this component should be removed and instead TitleDetailV2 should be used directly
const Titles = () => {
  const v2 = useContext(ConfigContext)?.titleConfig?.v2;
  if (v2) return <TitlesV2 />;

  const history = useHistory();
  const currentTableKey = useAppSelector(selectCurrentTableKey);
  const canReadTitles = useAppSelector(selectCanReadTitles);

  const onRowClick = (e: React.MouseEvent, item: TitleEntity) => {
    // the last item in lineage should be the top level id
    // if it's missing, that means this IS the top level id, so use the item.id
    const topLevelId = item?.lineage?.[item.lineage?.length - 1] || item.id;
    let url = `titles/${topLevelId}?tab=metadata`;
    if (item.lineage?.length) {
      // if there are 2 items in the lineage array, we can assume they are season and series
      if (item.lineage.length == 1) {
        url += `&season_id=${item.id}`;
      }
      // if there are 3 items in the lineage array, we can assume they are episode, season, and series
      else if (item.lineage.length == 2) {
        url += `&season_id=${item.lineage[0]}&${item.entity_type}_id=${item.id}`;
      }

      else if (item.lineage.length === 3) {
        url += `&season_id=${item.lineage[1]}&episode_id=${item.lineage[0]}&version_id=${item.id}`;
      }
    }

    if (e.ctrlKey || e.metaKey) {
      window.open(url);
    } else {
      history.push(url);
    }
  };

  if (!canReadTitles) return <NoRoute />;
  return (
    <DataTableLayout tableKey="titles" onRowClick={onRowClick}>
      <DataTableTitleBar />
      {currentTableKey === 'titles' && <DataTableFilters disableExportReport />}
    </DataTableLayout>
  );
};

export default Titles;
